'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Availability = require('./FutureDelivery/Availability');

var _Availability2 = _interopRequireDefault(_Availability);

var _availability = require('availability');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _User = require('./User');

var _User2 = _interopRequireDefault(_User);

var _Address = require('../Address');

var _Address2 = _interopRequireDefault(_Address);

var _PhoneUtils = require('../PhoneUtils');

var _PhoneUtils2 = _interopRequireDefault(_PhoneUtils);

var _wixRestaurantsJsSdk = require('wix-restaurants-js-sdk');

var _I18n = require('../I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _LocaleUtils = require('../LocaleUtils');

var _LocaleUtils2 = _interopRequireDefault(_LocaleUtils);

var _AdjustAvailability = require('../AdjustAvailability');

var _AdjustAvailability2 = _interopRequireDefault(_AdjustAvailability);

var _AvailabilityPrinter = require('../AvailabilityPrinter');

var _AvailabilityPrinter2 = _interopRequireDefault(_AvailabilityPrinter);

var _Time = require('../Time');

var _Time2 = _interopRequireDefault(_Time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var conjunct = _availability.iteratorFactory.conjunct,
    iter = _availability.iteratorFactory.iter;

var _i18n$getComponentHea = _I18n2.default.getComponentHeader(),
    I18N_EXTERNAL = _i18n$getComponentHea.I18N_EXTERNAL;

var self = {};

self.isEnabled = function (organization) {
    var result = { isEnabled: false };

    if (organization && organization.reservations && organization.reservations.availability) {
        var it = iter(organization.reservations.availability)((0, _momentTimezone2.default)());

        if (it.hasNext()) {
            var next = it.next();

            if (next.status === 'unavailable' && next.until === null) {
                result.reason = next.reason;
                result.comment = next.comment;
            } else {
                result.isEnabled = true;
            }
        }
    }

    return result;
};

self.getFirstAvailableDay = function (reservations, from, timezone) {
    var availability = _lodash2.default.get(reservations, 'availability', {});
    var minFutureDelayMins = _lodash2.default.get(reservations, 'futureDelayMins.min', 0);
    var availabilityHelper = new _Availability2.default(_momentTimezone2.default);
    var delayedNow = _momentTimezone2.default.tz(new Date(), timezone).add(minFutureDelayMins, 'm');

    if (from.isBefore(delayedNow)) {
        from = delayedNow;
    }

    var first = availabilityHelper.getFirstAvailabilityStartTime(availability, from);

    if (!first.isValid()) {
        first = null;
    }

    return first;
};

self.getNonAvailableDaysForPeriod = function (availability, openTimes) {
    var minFutureDelayMins = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var period = arguments[3];
    var periodIn = arguments[4];
    var from = arguments[5];
    var timezone = arguments[6];

    var firstDay = from.clone();
    var result = {};

    var it = conjunct(availability, openTimes)(firstDay);
    var startPeriod = firstDay;

    while (it.hasNext()) {
        var _it$next = it.next(),
            until = _it$next.until,
            status = _it$next.status;

        var nextMoment = _momentTimezone2.default.tz(until, timezone);

        if (status === 'available') {
            startPeriod = getClosestStartOfDay(nextMoment, true);
        } else {
            var endPeriod = getClosestStartOfDay(nextMoment, false);
            var dayLength = endPeriod.diff(startPeriod, 'days');
            if (dayLength === 0 && !endPeriod.isSame(startPeriod, 'day')) {
                dayLength = 1;
            }

            for (var i = 0; i < dayLength && Math.abs(startPeriod.diff(firstDay, periodIn)) < period; i++) {
                var day = _Time2.default.serializeDate(startPeriod);
                result[day] = true;
                startPeriod.add(1, 'days');
            }
        }

        if (Math.abs(nextMoment.diff(firstDay, periodIn)) >= period) {
            break;
        }
    }

    return result;
};

self.isValidReservation = function (restaurant, selectedDate) {
    var cal = _momentTimezone2.default.tz(restaurant.timezone);
    var reservationTimeCal = _momentTimezone2.default.tz(selectedDate, restaurant.timezone);
    var validation = _wixRestaurantsJsSdk.helpers.Restaurant.olrAvailable({ cal: cal, reservationTimeCal: reservationTimeCal, restaurant: restaurant });
    return parseValidationResponse(validation);
};

self.getReservationTimePrint = function (availability) {
    var openTimes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var dow = _LocaleUtils2.default.getFirstDayOfTheWeek(_I18n2.default.getLocale());
    var adjustedDayStrings = _AdjustAvailability2.default.adjustDayStrings(dow, _I18n2.default);
    var useAvailability = availability;

    if (!availability || !availability.weekly || availability.weekly.length === 0) {
        useAvailability = openTimes;
    }

    var av = _AdjustAvailability2.default.adjustAvailability(useAvailability, dow);

    var previewObj = {
        getDayToString: function getDayToString(day) {
            return day < 0 || day > 6 ? undefined : '' + adjustedDayStrings[day];
        },
        getPeriodStart: function getPeriodStart() {
            return '';
        },
        getPeriodEnd: function getPeriodEnd() {
            return '';
        },
        getDaysStart: function getDaysStart() {
            return '';
        },
        getDaysEnd: function getDaysEnd() {
            return '';
        },
        getPeriodDelimiter: function getPeriodDelimiter() {
            return I18N_EXTERNAL('openrest_olo_overview_separator');
        },
        getPeriodLastDelimiter: function getPeriodLastDelimiter() {
            return I18N_EXTERNAL('openrest_olo_overview_lastseparator');
        },
        getDayDashDelimiter: function getDayDashDelimiter() {
            return '-';
        },
        getHoursDashDelimiter: function getHoursDashDelimiter() {
            return '-';
        }
    };

    return _AvailabilityPrinter2.default.prettyPrint(av, previewObj);
};

self.getReservationHourOption = function (restaurant, selectedDate) {
    var stepInMinutes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15;

    var availability = _lodash2.default.get(restaurant, 'reservations.availability', {});
    var openTimes = _lodash2.default.get(restaurant, 'openTimes', {});
    var futureDelayMins = _lodash2.default.get(restaurant, 'reservations.futureDelayMins.min', 0);
    var timezone = _lodash2.default.get(restaurant, 'timezone', '');
    var hours = null;

    if (_momentTimezone2.default.isDate(selectedDate) || _momentTimezone2.default.isMoment(selectedDate)) {
        hours = selectedDayReservationHours(availability, openTimes, futureDelayMins, selectedDate, stepInMinutes, timezone);
    }

    if (!hours || !hours.length) {
        var _getWeeklyHourConjunc = getWeeklyHourConjunction(availability, openTimes, timezone),
            startTime = _getWeeklyHourConjunc.startTime,
            endTime = _getWeeklyHourConjunc.endTime;

        hours = generateHourOptionList([{ startTime: startTime, endTime: endTime }], stepInMinutes);
    }

    return hours;
};

self.getDisplayableReservation = function (reservation, restaurant, moment) {
    var actingAs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'customer';

    var displayStatus = actingAs === 'customer' ? getDisplayStatus(reservation) : getRestaurantDisplayStatus(reservation);
    var cancellationReason = getCancellationReason(reservation);
    var userExtraData = (0, _extends3.default)({}, _User2.default.getUserExtraData(reservation.user), reservation.user);
    var user = {
        profileLink: userExtraData.isFacebookUser ? 'https://www.facebook.com/' + reservation.user.clientId.id : null,
        profilePicture: userExtraData.urlPicture,
        fullName: _lodash2.default.get(reservation, 'contact.firstName') + ' ' + _lodash2.default.get(reservation, 'contact.lastName')
    };

    var displayReservation = (0, _extends3.default)({}, reservation, {
        displayStatus: displayStatus,
        user: user,
        restaurantConfirmedCancellation: reservation.status === 'canceled' && reservation.restaurantStatus === 'canceled'
    });

    if (cancellationReason) displayReservation.cancellationReason = cancellationReason;

    displayReservation.isCancelable = reservation.status === 'new' || reservation.status === 'accepted';

    if (restaurant) {
        displayReservation.restaurantTitle = restaurant.title[restaurant.locale];
        displayReservation.restaurantPhone = _PhoneUtils2.default.displayPhone(_lodash2.default.get(restaurant, 'contact.phone'), restaurant.address.countryCode);
        displayReservation.restaurantAddress = (_Address2.default.addressParts(restaurant) || []).join(' ');
    }

    if (moment && typeof moment.duration === 'function') {
        displayReservation.received = moment.duration(reservation.created - Date.now()).humanize(true);
    }

    return displayReservation;
};

function getDisplayStatus(reservation) {
    return getCancellationDisplayStatus(reservation) || reservation.status;
}

function getRestaurantDisplayStatus(reservation) {
    return getCancellationDisplayStatus(reservation) || reservation.restaurantStatus;
}

function getCancellationDisplayStatus(reservation) {
    if (reservation.status === 'canceled') {
        var cancellationEntry = _lodash2.default.find(reservation.log, function (l) {
            return l.type === 'status' && l.status === 'canceled';
        });

        if (cancellationEntry) {
            if (cancellationEntry.actingAs === 'restaurant') return 'canceledByRestaurant';

            if (cancellationEntry.actingAs === 'customer') return 'canceledByCustomer';
        }

        return 'canceled';
    }
}

function getCancellationReason(reservation) {
    var cancellationEntry = _lodash2.default.find(reservation.log, function (l) {
        return l.type === 'status' && l.status === 'canceled';
    });

    return _lodash2.default.get(cancellationEntry, 'comment');
}

function getClosestRoundedTime(time, stepInMinutes) {
    var timeMinutes = time.get('minute');
    var newMinutes = Math.ceil(timeMinutes / stepInMinutes) * stepInMinutes;
    return time.clone().set('minute', newMinutes);
}

function parseValidationResponse(validation) {
    var isValid = true;

    if (validation.until && (validation.isPast || validation.isLate || validation.isEarly)) {
        isValid = {
            status: _lodash2.default.findKey(_lodash2.default.pick(validation, ['isPast', 'isLate', 'isEarly']), function (value) {
                return value === true;
            })
        };
    } else if (validation.status === 'unavailable') {
        isValid = { status: 'unavailable' };
        if (!validation.until) {
            isValid.reason = 'closed';
        } else if (!!validation.comment) {
            isValid.reason = validation.comment;
        } else if (!validation.comment) {
            isValid.reason = 'bad_time';
        }
    }

    return isValid;
}

function selectedDayReservationHours(availability, openTimes, futureDelayMins, selectedDate, stepInMinutes, timezone) {
    var now = _momentTimezone2.default.tz(new Date(), timezone);
    var startTime = _momentTimezone2.default.tz(selectedDate, timezone).clone().startOf('day');
    var delayedStart = getClosestRoundedTime(now.clone().add(futureDelayMins, 'minutes'), stepInMinutes);
    startTime = startTime.isAfter(delayedStart) ? startTime : delayedStart;
    var it = conjunct(availability, openTimes)(startTime);
    var hours = [];
    var shouldBreak = false;
    var endTime = null;

    while (it.hasNext()) {
        var next = it.next();

        if (!next.until) {
            endTime = startTime.clone().endOf('day');
            hours.push({ startTime: startTime.clone(), endTime: endTime.clone() });
            break;
        }

        switch (next.status) {
            case 'available':
                endTime = _momentTimezone2.default.tz(next.until, timezone);
                break;
            case 'unavailable':
                startTime = _momentTimezone2.default.tz(next.until, timezone);
                break;
        }

        if (endTime) {
            if (!endTime.isSame(selectedDate, 'day')) {
                shouldBreak = true;
                endTime = startTime.clone().endOf('day');
            }
            hours.push({ startTime: startTime.clone(), endTime: endTime.clone() });
            endTime = null;
        }
        if (!startTime.isSame(selectedDate, 'day')) {
            shouldBreak = true;
        }

        if (shouldBreak) {
            break;
        }
    }

    return generateHourOptionList(hours, stepInMinutes);
}

function getWeeklyHourConjunction(availability, openTimes, timezone) {
    var startOfWeek = _momentTimezone2.default.tz(new Date(), timezone).startOf('week');
    var min = 0;
    var max = 24;
    var it = conjunct(availability, openTimes)(startOfWeek);

    while (it.hasNext()) {
        var next = it.next();

        if (!next.until) {
            break;
        }

        var until = _momentTimezone2.default.tz(next.until, timezone);

        if (until.diff(startOfWeek, 'w') >= 1) {
            break;
        }

        var hour = until.hours() + until.minutes() / 60;

        switch (next.status) {
            case 'available':
                max = hour < max ? hour : max;
                break;
            case 'unavailable':
                min = hour > min ? hour : min;
                break;
        }
    }

    if (max <= min) {
        min = 0;
        max = 24;
    }

    return {
        startTime: _momentTimezone2.default.tz(new Date(), timezone).startOf('day').hours(Math.floor(min)).minutes(60 * (min - Math.floor(min))),
        endTime: _momentTimezone2.default.tz(new Date(), timezone).startOf('day').hours(Math.floor(max)).minutes(60 * (max - Math.floor(max)))
    };
}

function generateHourOptionList(hours, stepInMinutes) {
    var duration = _momentTimezone2.default.duration({ 'minutes': stepInMinutes });
    var options = [];

    _lodash2.default.forEach(hours, function (_ref) {
        var startTime = _ref.startTime,
            endTime = _ref.endTime;

        var dstDiffMins = endTime.utcOffset() - startTime.utcOffset();
        var start = startTime.clone();
        var minutesDiff = endTime.diff(startTime, 'm') + dstDiffMins;
        var dstFix = 0;
        var prevStart = start.clone();

        for (var i = 0; i < minutesDiff; i += stepInMinutes) {
            dstFix = dstFix || !dstFix && start.utcOffset() - prevStart.utcOffset();
            var t = getClosestRoundedTime(start, stepInMinutes);

            options.push({
                hour: (t.get('hours') + 24 - dstFix / 60) % 24,
                minutes: t.get('minutes')
            });

            prevStart = start.clone();
            start.add(duration);
        }
    });

    return options;
}

function getClosestStartOfDay(theMoment, isNextDay) {
    var result = theMoment.clone();
    var startOfDayMoment = result.clone().startOf('day');

    if (Math.abs(result.diff(startOfDayMoment, 'minutes')) > 0) {
        if (isNextDay) {
            result.add(1, 'days');
        }
        result.startOf('day');
    }

    return result;
}

exports.default = self;